export default __webpack_public_path__ + "static/media/naidi-5.a26181e6.svg";